module.exports = __webpack_public_path__ + "media/images/icon__compete@2x-e5db6d63e0b93d37e91b73f1b5b84b5e.png";